module.exports = __webpack_public_path__ + "static/img/fromimg.73ec440.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fromimg.png
// module id = II1Z
// module chunks = 1